import React from 'react';
import PropTypes from 'prop-types';
import BaseTransition from './BaseTransition';

const direction = {
  left: {
    entering: {
      transform: 'translateX(-100vh)'
    },
    entered: {
      transform: 'translateX(0)'
    },
    exiting: {
      transform: 'translateX(-100vh)'
    },
    exited: {
      transform: 'translateX(-100vh)'
    }
  },
  right: {
    entering: {
      transform: 'translateX(100vh)'
    },
    entered: {
      transform: 'translateX(0)'
    },
    exiting: {
      transform: 'translateX(100vh)'
    },
    exited: {
      transform: 'translateX(100vh)'
    }
  },
  top: {
    entering: {
      transform: 'translateY(-100vh)'
    },
    entered: {
      transform: 'translateY(0)'
    },
    exiting: {
      transform: 'translateY(-100vh)'
    },
    exited: {
      transform: 'translateY(-100vh)'
    }
  },
  bottom: {
    entering: {
      transform: 'translateY(100vh)'
    },
    entered: {
      transform: 'translateY(0)'
    },
    exiting: {
      transform: 'translateY(100vh)'
    },
    exited: {
      transform: 'translateY(100vh)'
    }
  }
};

const SlideTransition = props => {
  const { duration, slideFrom, ...rest } = props;
  const baseStyles = {
    transition: `opacity ${duration}ms ease, transform ${duration}ms ease`,
    willChange: 'opacity, transform'
  };
  return (
    <BaseTransition
      {...rest}
      baseStyles={baseStyles}
      duration={duration}
      transitionStyles={direction[slideFrom]}
    />
  );
};

SlideTransition.propTypes = {
  duration: PropTypes.number,
  slideFrom: PropTypes.oneOf(['bottom', 'left', 'right', 'top'])
};

SlideTransition.defaultProps = {
  duration: 0,
  slideFrom: 'bottom'
};

export default SlideTransition;
